import React, { Suspense, useMemo, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { FlexBox } from '@ecp/common/src/layouts/flex/styled';

import { contentsUtilityState } from '@bo-recoil/common/atom';
import useContentsScrollTop from '@bo-hooks/common/useContentsScrollTop';
import SuspenseSpinner from '@bo-components/common/SuspenseSpinner';
import ContentsPageTitle from '@bo-layout/contents/ContentsPageTitle';

const Contents = (props) => {
  const { children } = props;
  const { pathname, search } = useLocation();
  const hasContentsUtility = useRecoilValue(contentsUtilityState);
  const homeMain = useMemo(() => pathname === '/', [pathname]);
  const scrollRef = useRef(null);
  useContentsScrollTop(scrollRef.current);

  return (
    <ScrollBoundary id="ecp-bo-contents" hasUtility={hasContentsUtility} homeMain={homeMain} ref={scrollRef}>
      <Container>
        {pathname !== '/' && (
          <>
            <ContentsPageTitle menuUrl={`${pathname}${search}`} />
          </>
        )}
        <Suspense fallback={<SuspenseSpinner />}>{children}</Suspense>
      </Container>
    </ScrollBoundary>
  );
};

const ScrollBoundary = styled(FlexBox)`
  height: calc(100vh - 50px - ${({ hasUtility }) => (hasUtility ? 60 : 0)}px);
  align-items: flex-start;
  overflow: auto;

  @media only screen and (min-width: 1440px) {
    overflow-x: hidden;
  }

  ${({ homeMain }) =>
    homeMain &&
    css`
      background-color: #e9eaf0;
    `}
`;

const Container = styled(FlexBox)`
  min-width: 1160px;
  height: fit-content;
  padding: 0 30px 60px 30px;
  position: relative;
  flex-grow: 1;
  flex-shrink: 1;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  box-sizing: border-box;
`;

export default Contents;

Contents.propTypes = {
  children: PropTypes.node,
};
